<template>
  <v-card>
    <v-img>
      <v-container>
        <v-row
          class="pt-3"
          justify="center"
        >
          <v-avatar
            :size="$vuetify.breakpoint.xsOnly?150:175"
            color="cyan darken-3"
          >
            <img
              v-if="contact.avatar"
              :src="contact.avatar"
            >
            <v-icon
              v-else
              size="160px"
              dark
            >
              mdi-account
            </v-icon>
          </v-avatar>
        </v-row>
      </v-container>
    </v-img>
    <v-card-title>
      <div
        style="width: 100%"
        class="text-center"
      >
        <span
          class="body-1"
          v-text="contact.name"
        /><br>
        <span
          class="body-1 grey--text"
          v-text="contact.role"
        />
      </div>
    </v-card-title>
    <v-card-actions>
      <div
        style="width: 100%"
        class="text-center"
      >
        <v-btn
          v-if="contact.email"
          text
          icon
          target="_BLANK"
          :href="`mailto:${contact.email}`"
        >
          <v-icon color="primary darken-1">
            mdi-email
          </v-icon>
        </v-btn>
        <v-btn
          v-if="contact.linkedIn"
          text
          icon
          target="_BLANK"
          :href="contact.linkedIn"
        >
          <v-icon color="primary darken-1">
            mdi-linkedin
          </v-icon>
        </v-btn>

        <v-btn
          v-if="contact.scholar"
          text
          icon
          target="_BLANK"
          :href="contact.scholar"
        >
          <v-icon color="primary darken-1">
            mdi-school
          </v-icon>
        </v-btn>

        <v-btn
          v-if="contact.personal"
          text
          icon
          target="_BLANK"
          :href="contact.personal"
        >
          <v-icon color="primary darken-1">
            mdi-account-card-details-outline
          </v-icon>
        </v-btn>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    contact: {
      required: true,
      type: Object
    }
  }
}
</script>
